export enum DebugMode {
    DEBUG_ON = `DEBUG_ON`,
    DEBUG_OFF = `DEBUG_OFF`,
}